var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, Box } from "@mui/material";
import { useElementConditions, useFormLogic, } from "../../context/FormLogicContext";
import { buildFieldValidation } from "../../validators/field-components";
import Header from "../common/Header";
import TextFieldInput from "./TextFieldInput";
import { getInitialValueForElement, resolveTextUpdateMode, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { resolveElementMinMax } from "../../../../utils/date-limits";
import { createInputMaskInstance } from "../../utils/mask-utils";
import MaskedTextField from "../common/MaskedTextField";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var inputTypesToAvoidMaxLengthValidation = [
    "color",
    "date",
    "datetime-local",
    "month",
    "range",
    "time",
    "week",
];
var TextField = function (_a) {
    var _b;
    var element = _a.element, errors = _a.errors;
    var _c = useFormLogic(), globalConstraints = _c.globalConstraints, globalTextUpdateMode = _c.textUpdateMode, formValues = _c.formValues;
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var error = errors[valueKey];
    var _d = useElementConditions(element), isVisible = _d.isVisible, isEnabled = _d.isEnabled, isInteractive = _d.isInteractive, fieldRequired = _d.isRequired;
    var _e = useMemo(function () { return resolveElementMinMax(element, formValues); }, [element, formValues]), min = _e.min, max = _e.max;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
            min: min,
            max: max,
        });
    }, [element, fieldRequired, isEnabled, min, max]);
    var inputTypeNeedsMaxLengthValidation = !element.inputType ||
        !inputTypesToAvoidMaxLengthValidation.includes(element.inputType);
    var fieldMaxLength = inputTypeNeedsMaxLengthValidation
        ? (_b = element.maxLength) !== null && _b !== void 0 ? _b : globalConstraints.maxTextLength
        : undefined;
    var mask = useMemo(function () { return createInputMaskInstance(element); }, [element]);
    var textUpdateMode = resolveTextUpdateMode(element, {
        textUpdateMode: globalTextUpdateMode,
    });
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: [valueKey],
        unregister: unregister,
    });
    var initialValue = getInitialValueForElement(element);
    return (_jsx(_Fragment, { children: isVisible ? (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ fullWidth: true, error: !!error, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!error, isRequired: fieldRequired }), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            if (mask) {
                                return (_jsx(MaskedTextField, { mask: mask, element: element, field: field, error: error, isEnabled: isInteractive, textUpdateMode: textUpdateMode }));
                            }
                            return (_jsx(TextFieldInput, { field: field, element: element, textUpdateMode: textUpdateMode, error: !!error, errorMessage: (error === null || error === void 0 ? void 0 : error.message) || "", isEnabled: isInteractive, fieldMaxLength: fieldMaxLength, min: min, max: max }));
                        } })] })) }))) : null }));
};
export default TextField;
